//@ts-nocheck
import classNames from 'classnames';

import { t } from '@web-solutions/module-localization';

import { Text } from 'core/ui-elements';

import { Base } from '../base';

import classes from '../../style.module.scss';
import { IMAGES } from '../../images';

const tKey = 'core.subscription.error_popup.decline_reasons.payment_amount_limit';

interface Props {
  onClick: () => void;
}

export const PaymentAmountLimit: React.FC<Props> = ({ onClick }) => {
  const options = t(`${tKey}.options`, { returnObjects: true }) as unknown as string[];

  return (
    <Base subtitle={t(`${tKey}.subtitle`)} withButton withFooter onClick={onClick}>
      <>
        <Text className={classes.optionsTitle}>{t(`${tKey}.title`)}</Text>
        {options.map((option, indx) => {
          return (
            <>
              <Text
                className={classes.option}
                components={{ b: <span className={classes.highlight} /> }}
              >
                {`${indx + 1} ${option}`}
              </Text>
              {indx === 0 && (
                <>
                  <Text
                    className={classNames(classes.baseText, classes.amountLimitText)}
                    components={{ b: <span className={classes.highlight} /> }}
                  >
                    {`${tKey}.card`}
                  </Text>
                  <img
                    className={classes.amountLimitCardImage}
                    src={IMAGES.IMAGE_CARD.src}
                    srcSet={IMAGES.IMAGE_CARD.srcSet}
                    alt='card'
                  />
                </>
              )}
            </>
          );
        })}
      </>
    </Base>
  );
};
